import {useContext} from 'react';
import {Link, SubLink} from 'react-router-dom';
import { useRef } from 'react';
import NavigationComponent from '../../navigation/navigation.component';
import bizzybrie from '../../images/games/bizzy-brie.png';
import { Background, Logo, Paragraph, Pinky} from './home.styles';

const HomePage = () => {

    return (
        <Background>
            <NavigationComponent></NavigationComponent>
            <Logo src={bizzybrie}></Logo>
            <Paragraph><strong>Project Type:</strong> Website <br/>
                <strong>Date Completed:</strong> March 2025<br/>
                <strong>Skills Used:</strong> Javascript, React, Styled Components, HTML, CSS, Firebase</Paragraph>
                <Pinky></Pinky>
        </Background>
    )
}

export default HomePage;